"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressModel = void 0;
const validator_1 = require("@leavy/validator");
const Address_1 = require("../domain/Address");
/**
 * A mailing address
 */
class AddressModel extends Address_1.Address {
}
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AddressModel.prototype, "address", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsOptional)(),
    __metadata("design:type", String)
], AddressModel.prototype, "additionalInformations", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AddressModel.prototype, "city", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsOptional)(),
    __metadata("design:type", String)
], AddressModel.prototype, "postalCode", void 0);
__decorate([
    (0, validator_1.IsString)(),
    (0, validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], AddressModel.prototype, "countryCode", void 0);
__decorate([
    (0, validator_1.IsLatitude)(),
    (0, validator_1.IsOptional)(),
    __metadata("design:type", Number)
], AddressModel.prototype, "lat", void 0);
__decorate([
    (0, validator_1.IsLongitude)(),
    (0, validator_1.IsOptional)(),
    __metadata("design:type", Number)
], AddressModel.prototype, "lng", void 0);
exports.AddressModel = AddressModel;
//# sourceMappingURL=Address.js.map